const { hostname } = window.location;

export const isLocal =
  hostname === 'localhost' || hostname.endsWith('.samera.one.localhost');
export const oneIdentifier =
  hostname === 'localhost' ? 'test' : hostname.split('.')[0];
export const isStaging = hostname.includes('.staging.');
